export default __webpack_public_path__ + "static/media/logo_mini.d6e2a787.png";